export default __webpack_public_path__ + "static/media/mostrar.47e88e57.svg";